import React from 'react';

import { useField } from 'formik';

import ComboBoxInput from 'components-new/combo-box-input/combo-box-input';
import type { Option } from 'components-new/combo-box-input/combo-box-input';
import type { EmptyStateProps } from 'components-new/empty-state/empty-state';

interface ComboBoxFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  name: string;
  options: Option[];
  onValueChange?: (value: string) => void;
  comboBoxInputClassName?: string;
  OptionsContainerClassName?: string;
  optionClassName?: string;
  emptyStateProps?: EmptyStateProps;
  animated?: boolean;
}

const ComboBoxField: React.FC<ComboBoxFieldProps> = (props) => {
  const {
    name,
    options,
    onValueChange,
    comboBoxInputClassName,
    OptionsContainerClassName,
    optionClassName,
    emptyStateProps,
    animated,
    multiple = false,
    ...inputFieldProps
  } = props;
  const [field, meta] = useField(name);

  return (
    <>
      <ComboBoxInput
        name={field.name}
        options={options}
        multiple={multiple as true} // workaround for not being able to pass boolean value
        animated={animated}
        onValueChange={onValueChange}
        emptyStateProps={emptyStateProps}
        comboBoxInputClassName={comboBoxInputClassName}
        OptionsContainerClassName={OptionsContainerClassName}
        optionClassName={optionClassName}
        error={meta.touched ? meta.error : undefined}
        {...inputFieldProps}
      />
    </>
  );
};

export default ComboBoxField;
